module.exports = __webpack_public_path__ + "img/s2-hx-3.3119678f.png";